import accountApi from '../api/accountApi';
import {showMessage} from '../../message/action/messageActions';
import ErrorCode from '../../common/enums/ErrorCode';
import React from 'react';
import {useTranslation} from 'react-i18next';

export function handleEmailChange(value, setEmail, setLoginError) {
    setEmail(value);
    setLoginError(null);
}

export function handleResendConfirmation(email, setLoginError) {
    setLoginError(null);
    accountApi.requestConfirmationLink(email).then((res) => {
            if (res.data.success) {
                dispatch(showMessage('Error.ACCOUNT_NOT_CONFIRMED_RESEND', {email: email}));
            }
        }
    );
}

export function createErrorMessage(loginError) {
    const [t] = useTranslation();
    let errorMessage = null;
    if (ErrorCode.INVALID_AUTHENTICATION.code === loginError) {
        errorMessage = <>{t('Error.INVALID_AUTHENTICATION')}</>;
    }
    if (ErrorCode.ACCOUNT_NOT_CONFIRMED.code === loginError) {
        errorMessage = (
            <>
                {t('Error.ACCOUNT_NOT_CONFIRMED')}
                <div>
                    <a onClick={handleResendConfirmation} href="#">{`${t('Error.ACCOUNT_CONFIRMATION_HINT')} ${t('Error.ACCOUNT_NOT_CONFIRMED_LINK')}`}</a>
                </div>
            </>
        );
    }
    return errorMessage;
}
